/* ds-brew-ways.js — табы способов заваривания (sections/ds-brew-ways.liquid).
   role=tab / tabpanel: клик и стрелки ←→, Home/End переключают панель;
   в RTL стрелки следуют направлению чтения. Идемпотентно для редактора темы. */
(function () {
  'use strict';

  function activate(root, name, focus) {
    var tabs = root.querySelectorAll('[data-brew-tab]');
    var panels = root.querySelectorAll('[data-brew-panel]');
    tabs.forEach(function (tab) {
      var on = tab.dataset.brewTab === name;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      if (on && focus) tab.focus();
    });
    panels.forEach(function (panel) {
      panel.hidden = panel.dataset.brewPanel !== name;
    });
  }

  function init(root) {
    root.querySelectorAll('[data-brew-ways]').forEach(function (section) {
      if (section.dataset.brewWaysInit) return;
      section.dataset.brewWaysInit = 'true';
      var list = section.querySelector('[data-brew-tabs]');
      if (!list) return;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-brew-tab]'));
      var rtl = getComputedStyle(list).direction === 'rtl';

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(section, tab.dataset.brewTab, false);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          var forward = rtl ? 'ArrowLeft' : 'ArrowRight';
          var back = rtl ? 'ArrowRight' : 'ArrowLeft';
          if (event.key === forward) next = tabs[(index + 1) % tabs.length];
          else if (event.key === back) next = tabs[(index - 1 + tabs.length) % tabs.length];
          else if (event.key === 'Home') next = tabs[0];
          else if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          activate(section, next.dataset.brewTab, true);
        });
      });
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
